import { DetailListItem } from 'components/site/modals/DetailListModal/DetailListItem';
import { useAnalytics } from 'libs/utils/site/analytics';
import _ from 'lodash';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storyIds: string[];
}

export const DetailList = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);
    const analytics = useAnalytics();

    const openStory = async (storyId: string) => {
        ctxModal.setStoryList({
            visibleStoryIds: props.storyIds,
            currentIndex: props.storyIds.findIndex((e) => e === storyId)
        });

        ctxModal.setDetailModal({
            id: storyId,
            detail: ctxView.allDetails.find((e) => e.storyId === storyId),
            markerId: null
        });

        analytics.track('sidebar_list_item.clicked', {
            action: 'detail.opened'
        });
    };

    const stories =
        ctxModal.detailListModal?.show === 'all' ? ctxView.allDetails : ctxView.conectedDetails;

    if (!stories) {
        return null;
    }

    let visibleStories = stories.filter((e) => props.storyIds.includes(e.storyId));

    // Default is by header.title
    if (!ctxModal.detailListModal?.sort || ctxModal.detailListModal?.sort === 'title') {
        visibleStories = _.orderBy(visibleStories ?? [], ['header.title'], ['asc']);
    } else if (ctxModal.detailListModal?.sort === 'none') {
        visibleStories = _.orderBy(visibleStories ?? [], (e1) =>
            props.storyIds.indexOf(e1.storyId)
        );
    }

    return (
        <S_DetailList className={props.className}>
            {visibleStories.map((story) => {
                return (
                    <S_DetailListItem
                        key={story.storyId}
                        story={story}
                        onClick={() => {
                            openStory(story.storyId);
                        }}
                    />
                );
            })}
        </S_DetailList>
    );
};

const S_DetailList = styled.div`
    padding: 10px 10px 0 10px;
`;

const S_DetailListItem = styled(DetailListItem)`
    margin-bottom: 10px;
`;
